import React from 'react';
import { Feature } from '../../comp/';
import './whatGPT3.css';

const WhatGPT3 = () => {
  return (
    <div className='gpt3__whatgpt3 section_margin' id='empresa'>
      <div className='gpt3__whatgpt3-feature'>
        <Feature title="Nosso Propósito" text="Transformar ideias em produtos inovadores. Estamos focados na qualidade e eficiência, desenvolvendo softwares e aplicativos de fácil uso que impulsionam o crescimento empresarial em Moçambique."/>
      </div>

      <div className='gpt3__whatgpt3-heading'>
        <h1>Uma Ideia, Um Produto</h1>
        <p>Explorar nossos produtos</p>
      </div>

      <div className='gpt3__whatgpt3-container'>
        <Feature title="Visão" text="Ser referência em desenvolvimento de softwares e aplicativos inovadores em Moçambique e África, impulsionando a transformação digital dos nossos clientes."/>
        <Feature title="Missão" text="Desenvolver softwares e aplicativos sustentáveis, de fácil uso e que resolvam problemas reais do mercado moçambicano."/>
        <Feature title="Valores" text="Inovação contínua, qualidade sem compromissos, sustentabilidade ambiental, e soluções que promovem mobilidade e acessibilidade."/>
      </div>
    </div>
  )
}

export default WhatGPT3
